import type { CoreQuestionListResponse } from '@dmp/qqms/data-access';
import { mapById } from '@dmp/shared/helpers';
import type { StoreState } from '../../state-types';
import { switchEditingCoreQuestion } from './switch-editing-core-question';

/** Set/consume Core Questions state with data from the API response  */
export const setCoreQuestionsFromResource =
    (
        coreQuestionsResource: CoreQuestionListResponse,
        activeCardId?: string | null
    ) =>
    (state: StoreState): StoreState => {
        const newState: StoreState = {
            ...state,
            coreQuestions: mapById(coreQuestionsResource.data),
        };

        // set data for display the active card
        if (activeCardId) {
            return switchEditingCoreQuestion(activeCardId)(newState);
        }

        return newState;
    };
